import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationAccountSetOAuthRedirectAllowlistArgs } from "types/generated";

type OauthRedirectAllowlistData = {
  oauthRedirectAllowedHosts: string[];
};

export const GET_OAUTH_REDIRECT_ALLOWLIST: TypedDocumentNode<OauthRedirectAllowlistData> = gql`
  query GetOauthRedirectAllowlist {
    oauthRedirectAllowedHosts
  }
`;

type SetOauthRedirectAllowlistData = {
  accountSetOAuthRedirectAllowlist: string[];
};

export const SET_OAUTH_REDIRECT_ALLOWLIST: TypedDocumentNode<
  SetOauthRedirectAllowlistData,
  MutationAccountSetOAuthRedirectAllowlistArgs
> = gql`
  mutation SetOauthRedirectAllowlist($hosts: [String!]!) {
    accountSetOAuthRedirectAllowlist(hosts: $hosts)
  }
`;
